import axios from 'axios';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import NplCardList from './NplCardList';

function NplHilight() {
  const stats = [
    { name: 'NPL 등록 수', value: '' },
    { name: '법사가 총액', value: '' },
    { name: '근저당권 설정금액', value: '' },
    { name: '대출원금 총액', value: '' },
  ];

  const [visibleStats, setVisibleStats] = useState(stats);

  const stat = async () => {
    try {
      const data = await axios.get(`https://nplatform.ai/api/ocr/stat`);
      return data.data;
    } catch (error) {
      console.error('Error fetching stats:', error);
      return {
        data: {
          r_cnt: 0,
          at_prc: 0,
          st_prc: 0,
          lt_prc: 0,
        },
      };
    }
  };

  function formatKoreanNumber(num: number): string {
    if (num === 0) return '';
    const units = ['', '만', '억', '조', '경'];
    let result = '';
    let unitIndex = 0;
    while (num > 0) {
      const part = num % 10000;
      if (part > 0 && unitIndex > 1) {
        result =
          part.toLocaleString() +
          units[unitIndex] +
          (result ? ' ' + result : '');
      }
      num = Math.floor(num / 10000);
      unitIndex++;
    }
    return result.trim();
  }

  const getStat = async () => {
    const resut = await stat();
    setVisibleStats([
      {
        name: 'NPL 등록 수',
        value: Number(resut.data.r_cnt).toLocaleString() + '개',
      },
      {
        name: '감정평가 총액 (단위: 백만원)',
        value: formatKoreanNumber(Number(resut.data.at_prc)),
      },
      {
        name: '근저당권 설정금액 (단위: 백만원)',
        value: formatKoreanNumber(Number(resut.data.st_prc)),
      },
      {
        name: '대출원금 총액 (단위: 백만원)',
        value: formatKoreanNumber(Number(resut.data.lt_prc)),
      },
    ]);
  };

  useEffect(() => {
    getStat();
  }, []);

  return (
    <Container>
      <Header>
        <TitleBox>
          <Title>NPL 플랫폼 하이라이트</Title>
          <NplButton onClick={() => window.open('https://nplatform.ai/')}>
            NPL 둘러보기
            <img src="/assets/images/icon/open-in-new-gray.svg" alt="" />
          </NplButton>
        </TitleBox>
        <StatSection>
          {visibleStats.map((stat) => (
            <StatItem key={stat.name}>
              <StatTitle>{stat.name}</StatTitle>
              <StatValue>{stat.value}</StatValue>
            </StatItem>
          ))}
        </StatSection>
      </Header>
      <NplCardList />
    </Container>
  );
}

export default NplHilight;

const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 24px 0 24px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;

  border-radius: 16px 16px 0 0;
  background: #fff;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding-right: 16px;
  align-self: stretch;
`;

const TitleBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const Title = styled.div`
  color: rgba(0, 12, 30, 0.8);
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.32px;
`;

const NplButton = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;

  color: #4e5968;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const StatSection = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px 0;
  padding: 20px 24px;
  border-radius: 16px;
  background: #f7f8fc;
  align-self: stretch;
`;

const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  flex: 1 0 0;
`;

const StatTitle = styled.div`
  color: #616161;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const StatValue = styled.div`
  color: #222;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;
`;
